import "./NoDataFound.scss";
import NoDataImage from "../../../Assets/global/No_data_found.svg";

const NoDataFound = ()=> {

    return(
        <div className="no-data-wrapper">
           <img src={NoDataImage}/>
           <h3 className="no-data-text">No Data Found</h3>
        </div>
    )
};

export default NoDataFound;